import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as authenticate from "./authenticate";
import * as changePassword from "./changePassword";
import * as confirmAccountCreation from "./confirmAccountCreation";
import * as createAccount from "./createAccount";
import * as editPersonalWeeklyCalendar from "./editPersonalWeeklyCalendar";
import * as editUserPreferences from "./editUserPreferences";
import * as logOut from "./logOut";
import * as retrievePersonalWeeklyCalendar from "./retrievePersonalWeeklyCalendar";
import * as retrieveUserPreferences from "./retrieveUserPreferences";
import * as inviteMembers from "./inviteMembers";
import * as fillAccount from "./fillAccount";
import * as assignPersonalCalendarHolidays from "./assignPersonalCalendarHolidays";
import * as retrievePersonalCalendarHolidays from "./retrievePersonalCalendarHolidays";
import * as unAssignPersonalCalendarHolidays from "./unAssignPersonalCalendarHolidays";

const initialState: State = {
  authenticate: authenticate.initialState,
  changePassword: changePassword.initialState,
  confirmAccountCreation: confirmAccountCreation.initialState,
  createAccount: createAccount.initialState,
  editPersonalWeeklyCalendar: editPersonalWeeklyCalendar.initialState,
  editUserPreferences: editUserPreferences.initialState,
  logOut: logOut.initialState,
  retrievePersonalWeeklyCalendar: retrievePersonalWeeklyCalendar.initialState,
  retrieveUserPreferences: retrieveUserPreferences.initialState,
  inviteMembers: inviteMembers.initialState,
  fillAccount: fillAccount.initialState,
  assignPersonalCalendarHolidays: assignPersonalCalendarHolidays.initialState,
  retrievePersonalCalendarHolidays:
    retrievePersonalCalendarHolidays.initialState,
  unAssignPersonalCalendarHolidays:
    unAssignPersonalCalendarHolidays.initialState,
};

const reduceState = combineStateReducer(initialState, {
  authenticate: authenticate.reduceState,
  changePassword: changePassword.reduceState,
  confirmAccountCreation: confirmAccountCreation.reduceState,
  createAccount: createAccount.reduceState,
  editPersonalWeeklyCalendar: editPersonalWeeklyCalendar.reduceState,
  editUserPreferences: editUserPreferences.reduceState,
  logOut: logOut.reduceState,
  retrievePersonalWeeklyCalendar: retrievePersonalWeeklyCalendar.reduceState,
  retrieveUserPreferences: retrieveUserPreferences.reduceState,
  inviteMembers: inviteMembers.reduceState,
  fillAccount: fillAccount.reduceState,
  assignPersonalCalendarHolidays: assignPersonalCalendarHolidays.reduceState,
  retrievePersonalCalendarHolidays:
    retrievePersonalCalendarHolidays.reduceState,
  unAssignPersonalCalendarHolidays:
    unAssignPersonalCalendarHolidays.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...authenticate.createSelector(() => getState().authenticate),
    ...changePassword.createSelector(() => getState().changePassword),
    ...confirmAccountCreation.createSelector(
      () => getState().confirmAccountCreation,
    ),
    ...createAccount.createSelector(() => getState().createAccount),
    ...editPersonalWeeklyCalendar.createSelector(
      () => getState().editPersonalWeeklyCalendar,
    ),
    ...editUserPreferences.createSelector(() => getState().editUserPreferences),
    ...logOut.createSelector(() => getState().logOut),
    ...retrievePersonalWeeklyCalendar.createSelector(
      () => getState().retrievePersonalWeeklyCalendar,
    ),
    ...retrieveUserPreferences.createSelector(
      () => getState().retrieveUserPreferences,
    ),
    ...inviteMembers.createSelector(() => getState().inviteMembers),
    ...fillAccount.createSelector(() => getState().fillAccount),
    ...assignPersonalCalendarHolidays.createSelector(
      () => getState().assignPersonalCalendarHolidays,
    ),
    ...retrievePersonalCalendarHolidays.createSelector(
      () => getState().retrievePersonalCalendarHolidays,
    ),
    ...unAssignPersonalCalendarHolidays.createSelector(
      () => getState().unAssignPersonalCalendarHolidays,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
